export enum ContextMenuVariant {
  PRIMARY = "primary",
  DESTRUCTIVE = "destructive",
}

export interface ContextMenuItems<TData> {
  id: string;
  label?: string;
  icon?: React.ElementType;
  group?: string;
  className?: string;
  getDisabled?: (data: TData) => boolean;
  hidden?: boolean;
  showIf?: (data: TData) => boolean;
  getContent?: (data: TData) => React.ReactNode;
  preventCloseOnSelect?: boolean | ((data: TData) => boolean);
  tooltipContent?: string | ((data: TData) => string | undefined);
  infoTooltipContent?: string | ((data: TData) => string | undefined);
  onClick?: (data: TData) => void;
  isDivider?: boolean;
  variant?: ContextMenuVariant;
  subItems?: ContextMenuItems<TData>[];
}

export interface ContextMenuProps<TData> {
  contextMenuItems?: ContextMenuItems<TData>[];
  data: TData;
  children: React.ReactNode;
  isDisabled?: boolean;
  shouldOpenContextMenuByLeftClick?: boolean;
  className?: string;
  style?: React.CSSProperties;
  modal?: boolean;
  usePortal?: boolean;
  preventAutoFocusOnClose?: boolean;
}
